import React from "react";
import { useLocation } from "react-router-dom";
import BankActivationButton from "./components/button";
import BankActivationContent from "./components/content";
import BankActivationHeader from "./components/header";

import "./index.scss";

const BankActivation = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("status");
  const message = new URLSearchParams(location.search).get("message");

  return (
    <div className="max-w-3xl m-auto h-[100vh] bg-gray--12">
      <BankActivationHeader />
      <BankActivationContent isFailed={query === "failed"} message={message} />
      <BankActivationButton />
    </div>
  );
};

export default BankActivation;
